// extracted by mini-css-extract-plugin
module.exports = {"Maps":"Login_Maps__1gBuE","pass":"Login_pass__UH8eQ","FormContainer":"Login_FormContainer__2AJl4","Form":"Login_Form__3xdhe","ForgotPass":"Login_ForgotPass__12eNp"};